import React from 'react';
import Breadcrumb from '../../../components/common/Breadcrumb'


 <Breadcrumb current="Inventory / Store Transaction / MRQ " />

      {/* Header */}
      <div className="mt-2 mb-3 md:mb-5"></div>

const UserAccessPage = () => {
  return (
    <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md h-full">
      <h1 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">MRQ</h1>
      <p>Manage roles, permissions, and access here.</p>
    </div>
  );
};

export default UserAccessPage;   